<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" fill="none">
    <circle cx="40" cy="40" r="33.3333" fill="#F2BA00" stroke="#FA7E25" stroke-width="3.33333" />
    <rect x="23.3359" y="21.668" width="10" height="13.3333" rx="5" fill="#813612" />
    <rect x="25" y="23.332" width="5" height="5" rx="2.5" fill="white" />
    <path
      d="M20.4839 46.4775C20.2295 44.8236 21.5091 43.332 23.1825 43.332H56.8175C58.4909 43.332 59.7705 44.8236 59.5161 46.4775L59.201 48.5258C57.7429 58.0029 49.5885 64.9987 40 64.9987C30.4115 64.9987 22.2571 58.0029 20.799 48.5258L20.4839 46.4775Z"
      fill="#813612"
    />
    <path
      d="M40.002 55C44.4788 55 48.2681 57.942 49.543 61.998C46.8399 63.8889 43.5511 65 40.002 65C36.4528 65 33.164 63.8889 30.4609 61.998C31.7359 57.942 35.5251 55 40.002 55Z"
      fill="#E53973"
    />
    <rect x="46.6641" y="21.668" width="10" height="13.3333" rx="5" fill="#813612" />
    <rect x="48.3359" y="23.332" width="5" height="5" rx="2.5" fill="white" />
  </svg>
</template>
